import {
  GET_TICKETS,
  GET_TICKETS_SUCCESS,
  SET_LOADING,
  GET_DETAIL,
  GET_DETAIL_SUCCESS,
  SUBMIT_DATA,
  SUBMIT_DATA_SUCCESS,
  DELETE,
  DELETE_SUCCESS,
  REQUEST_ERROR,
  GET_REFERENCE_DATA_SUCCESS,
  ADD_TICKET_RESPONSE_SUCCESS,
} from '../types/ticket';
import { updateStates } from '../../utils/reducer';

const initState = {
  list: {
    data: [],
    metadata: {},
  },
  isLoading: false,
  error: '',
  item: {},
  orderStatus: [],
};

const reducer = (state = initState, action) => {
  const { type } = action;
  switch (type) {
    case GET_TICKETS:
    case GET_DETAIL:
    case SUBMIT_DATA:
    case DELETE:
      return updateStates(state, {
        isLoading: true,
      });

    case GET_TICKETS_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        list: action.data,
      });

    case GET_DETAIL_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: action.data,
      });

    case ADD_TICKET_RESPONSE_SUCCESS:
      const newData = action.payload?.thread ? action.payload : { thread: action.payload };
      return updateStates(state, {
        item: { ...state.item, ...newData },
      });

    case GET_REFERENCE_DATA_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        ...action.data,
      });
    case SET_LOADING:
      return updateStates(state, {
        isLoading: action.isLoading,
      });

    case REQUEST_ERROR:
      return updateStates(state, {
        isLoading: false,
      });

    case SUBMIT_DATA_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: action.data,
      });

    case DELETE_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        item: null,
      });
    default:
      return state;
  }
};

export default reducer;
